import React from "react";
import { Box, Paper, Typography, useTheme } from "@mui/material";

export default function InfoCard({ caption, value, valueColor, ...props }) {
  const theme = useTheme();
  return (
    <Paper elevation={0} sx={{ minWidth: theme.spacing(8) }}>
      <Box pl={2} pt={1} pr={2} pb={1}>
        <Typography variant="caption" display="block" sx={{ opacity: "0.5" }}>
          {caption}
        </Typography>
        <Box color={valueColor}>
          <Typography
            variant={props.variant || "h4"}
            display="block"
            sx={{ fontWeight: "500" }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}
